// libraries
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { Grid } from '@mui/material'

// state
import { showFormModal } from 'state/ui'

// queries
import { useGetBatchesQuery } from 'services/batches'

// generic components
import LedgerSyncLogGrid from 'components/generic/datagrid/LedgerSyncLogGrid'

// helpers and utils
import FORM_MODALS from 'utils/ui/modals'

const SyncLogContainer = () => {
  const dispatch = useDispatch()
  const { batchId } = useParams()

  const { data, isLoading } = useGetBatchesQuery({}, { refetchOnMountOrArgChange: true })
  const [transformedRowsBatches, setTransformedRowsBatches] = useState([])
  useEffect(() => {
    if (data) {
      setTransformedRowsBatches(
        data?.Items.slice()
          .sort((a, b) => new Date(b.dateTime) - new Date(a.dateTime))
          .map(item => ({
            id: parseInt(item.perYardBatchNumber, 10),
            batchNumber: item.batchNumber,
            status: item.status,
            user: item.userName,
            dateTime: item.dateTime,
          })),
      )
    }
  }, [data])

  useEffect(() => {
    if (batchId) {
      dispatch(
        showFormModal({
          formModalName: FORM_MODALS.SYNC_LOG_INFO,
          formModalProps: { batchId },
        }),
      )
    }
  }, [batchId])

  return (
    <Grid p={3} sx={{ height: '100%' }} container flexDirection="column">
      <LedgerSyncLogGrid rows={transformedRowsBatches} loading={isLoading} />
    </Grid>
  )
}

export default SyncLogContainer
